/**
 *  normal为图标分析模块下用户自定义菜单
 *  normalCtrl内根据不同的用户自定义菜单名修改面包屑名称和title名称
 */
class normalCtrl {
    constructor($scope, httpRequest) {
        $(() => {
            $(document)[0].title = localStorage.defaultName
        })
        $scope.paths = [{
            href: 'statistics.chartAnalysis.normal.list',
            title: localStorage.defaultName,
        }]
        httpRequest.post_queryReportUrl(localStorage.defaultKey).then((res) => {
            if (res.data.success) {
                $scope.url = res.data.value.url
            }
        })
    }
}

normalCtrl.$inject = ['$scope', 'httpRequest']
export default normalCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/normal/normalCtrl.js